import { VALUE_PHILOSOPHY_OPTIONS, type BrandSourceTag } from '@mg/shared';
import { PriceTier } from './PriceTier';
import { SourceTags } from './SourceTags';

/** What a read-only field without a value shows (spec:174). */
export const NOT_PROVIDED_TEXT = 'Not provided';

/**
 * A field the Edit page shows as text (spec:170-174): one row of a `<dl>`, the name (with its source
 * tags) and the text, line breaks kept. No value: "Not provided" in muted text. Value philosophy shows
 * its price tier BEFORE the option's name, then its description: "$$ Affordable — Competitive pricing
 * for everyday customers" (spec:251).
 */
export function ReadOnlyField({
  label,
  value,
  sources,
  aiSuggested = false,
  kind,
}: {
  label: string;
  /** The text, or for Value philosophy the stored value (AFFORDABLE …). */
  value: string | null;
  sources: readonly BrandSourceTag[];
  aiSuggested?: boolean;
  kind: 'text' | 'textarea' | 'valuePhilosophy';
}) {
  const text = value?.trim() ? value : null;
  const option = kind === 'valuePhilosophy' ? VALUE_PHILOSOPHY_OPTIONS.find((o) => o.value === value) : undefined;
  return (
    <div className="py-3">
      <dt className="flex flex-wrap items-start justify-between gap-x-3 gap-y-1 text-sm font-medium text-ink-strong">
        <span>{label}</span>
        <SourceTags sources={sources} aiSuggested={aiSuggested} />
      </dt>
      <dd className="mt-1 whitespace-pre-wrap break-words text-sm text-ink">
        {text === null ? (
          <span className="text-ink-faint">{NOT_PROVIDED_TEXT}</span>
        ) : option ? (
          <span className="inline-flex flex-wrap items-baseline gap-x-2">
            <PriceTier tier={option.tier} />
            <span>
              {option.label} — {option.description}
            </span>
          </span>
        ) : (
          text
        )}
      </dd>
    </div>
  );
}
